import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class ProductRequiredSerialNumberArgs extends ActionArgs {
  @Field(() => String)
  productId: string

  @Field(() => Boolean)
  requiredSerialNumber: boolean
}
